module.exports = __webpack_public_path__ + "img/104.9.79394e53.png";